module.exports = __webpack_public_path__ + "static/media/map_pin_roundabout.8847c70b.svg";